var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaycheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5894,
    r: 32,
    fill: "#F2F4F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22.5894,
    width: 40,
    height: 20,
    rx: 1.5,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3286 33.1626C19.2458 32.3567 18.4565 32.1758 17.7647 32.1729C16.8601 32.1685 15.9569 33.0317 16.2762 33.9493C16.5896 34.8508 17.6597 35.0287 18.4373 35.3493C18.7743 35.4875 19.1675 35.6758 19.3552 36.0037C19.5873 36.411 19.5267 36.9007 19.271 37.2816C19.0152 37.6625 18.6058 37.889 18.1431 37.9684C17.3922 38.0978 16.3161 37.9169 16.0545 37.0831C16.0101 36.9419 15.9953 36.7934 16.0012 36.6463",
    stroke: "#1A1E23",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 31.5894L17.75 38.5894",
    stroke: "#1A1E23",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0894C12 23.2609 12.6716 22.5894 13.5 22.5894H50.5C51.3284 22.5894 52 23.2609 52 24.0894V28.5894H12V24.0894Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M50 23.5894V24.5894H14V23.5894H50Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 38.5894H37",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 35.5894H47",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32.5894H47",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 38.5894L47 38.5894",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 38.5894L42 38.5894",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 25.5894,
    r: 1,
    fill: "#1A1E23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 25.5894,
    r: 1,
    fill: "#1A1E23"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 25.5894,
    r: 1,
    fill: "#1A1E23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaycheckIcon);
export default __webpack_public_path__ + "static/media/paycheck-icon.0c92683434adb9e8637b5be95c8f025c.svg";
export { ForwardRef as ReactComponent };